import * as React from "react";
import { useId } from "@floating-ui/react";
import { AccordionContent } from "../accordion/accordion-content/accordion-content.mjs";
import { AccordionHeader } from "../accordion/accordion-header/accordion-header.mjs";
import { AccordionItem } from "../accordion/accordion-item/accordion-item.mjs";
import { AccordionTitle } from "../accordion/accordion-title/accordion-title.mjs";
import { GridColumn } from "../grid/grid-column/grid-column.mjs";
import { Heading } from "../typography/heading/heading.mjs";
import { AccordionGridContext } from "./accordion-grid.mjs";
const AccordionGridItem = ({ accordionItem, gridColumn, title, children }) => {
  var _a;
  const { headingLevel, isSmallScreen } = React.useContext(AccordionGridContext);
  const id = (_a = useId()) != null ? _a : (
    /* istanbul ignore next */
    ""
  );
  return isSmallScreen ? /* @__PURE__ */ React.createElement(AccordionItem, { id, ...accordionItem }, /* @__PURE__ */ React.createElement(AccordionHeader, null, /* @__PURE__ */ React.createElement(AccordionTitle, null, title)), /* @__PURE__ */ React.createElement(AccordionContent, null, children)) : /* @__PURE__ */ React.createElement(GridColumn, { ...gridColumn }, /* @__PURE__ */ React.createElement(Heading, { level: headingLevel, className: "h3 accordion-grid__title" }, title), children);
};
export {
  AccordionGridItem
};
